import { Outlet } from 'react-router-dom';
import ThreeSceneTopBar from '@/components/ui/topBar/ThreeSceneTopBar';
import { DevDock } from '@modules/dev/DevDock';

export function ThreeSceneLayout() {
  return (
    <div className="flex h-full w-full rounded-3xl bg-tertiary">
      <DevDock />
      <div className="flex w-full flex-col gap-4">
        <div className="absolute w-full flex justify-center pt-4">
          <ThreeSceneTopBar />
        </div>
        <div className="flex flex-1 min-h-0 flex-col overflow-hidden">
          <Outlet />
        </div>
      </div>
    </div>
  );
}

export default ThreeSceneLayout;
